import React from 'react';
import { ToastOptions, toast } from 'react-toastify';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Typography from '@mui/material/Typography';
import theme from '@src/theme/theme';

import { dFlex } from '@assets/mixins';

import Link from '@components/common/Link';
import {
  boxStyles,
  boxWithHashLinkStyles,
} from '@components/common/Toast/styles';

import { TRX_LINK } from '@constants/common/chain.constants';
import {
  TOAST_DEFAULT_OPTIONS,
  ToastType,
} from '@constants/common/toast.constants';
import { Size } from '@constants/common/ui.constants';

type ToastContent = {
  title: string;
  description?: string;
  withLink?: {
    hash: string;
    chainId: number;
    title?: string;
  };
};

const COLOR_TYPE = {
  [ToastType.Success]: theme.palette.custom.accent.success,
  [ToastType.Error]: theme.palette.custom.accent.error,
  [ToastType.Info]: theme.palette.custom.accent.soft,
};

// Sky DS Notifications: check-circle for success, error-outline for the rest
const ICON_TYPE = {
  [ToastType.Success]: CheckCircleOutlineIcon,
  [ToastType.Error]: ErrorOutlineIcon,
  [ToastType.Info]: ErrorOutlineIcon,
};

const showToast = (
  content: ToastContent,
  type: ToastType,
  toastOptions?: {
    hideIcon?: boolean;
    hideClose?: boolean;
    showProgressBar?: boolean;
  },
) => {
  const Icon = ICON_TYPE[type];
  const options: ToastOptions = {
    ...TOAST_DEFAULT_OPTIONS,
    type,
    className: `toast-container-${type}`,
    icon: !toastOptions?.hideIcon && (
      <Icon style={{ color: COLOR_TYPE[type] }} fontSize={Size.Small} />
    ),
    closeButton: !!toastOptions?.hideClose,
    hideProgressBar: toastOptions?.showProgressBar,
  };

  const renderBlock = () => (
    <>
      <div
        style={
          content?.withLink ? { ...boxWithHashLinkStyles } : { ...boxStyles }
        }
      >
        <div>
          <Typography variant="body1" color={theme.palette.custom.text.white}>
            {content.title}
          </Typography>
          {content?.description && (
            <Typography
              variant="body1"
              color={theme.palette.custom.text.white}
              style={{ marginTop: '4px', ...dFlex() }}
            >
              {content.description}
            </Typography>
          )}
        </div>
        {content?.withLink && (
          <Link
            pathname={`${TRX_LINK[content.withLink.chainId]}${content.withLink.hash}`}
            isNewTab
            variant="subtitle1"
            color={theme.palette.custom.text.white}
          >
            {content.withLink?.title || 'View'}
          </Link>
        )}
      </div>
    </>
  );

  toast(renderBlock(), options);
};

export default showToast;
